module.exports = __webpack_public_path__ + "static/kento-f1621edbac41d9ff832517fbc5bfb96d.jpg";